const ACTIVE_APP_KEY = 'mel_active_app';

const isBrowser = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const safeGetItem = (key) => {
  if (!isBrowser()) return null;

  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn('Unable to access localStorage:', error);
    return null;
  }
};

const safeSetItem = (key, value) => {
  if (!isBrowser()) return;

  try {
    if (value === undefined || value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch (error) {
    console.warn('Unable to write to localStorage:', error);
  }
};

export const getActiveApp = () => {
  const raw = safeGetItem(ACTIVE_APP_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Unable to parse stored app:', error);
    return null;
  }
};

export const setActiveApp = (app) => {
  if (!app) {
    safeSetItem(ACTIVE_APP_KEY, null);
    return;
  }

  const payload = {
    id: app.id || app._id || `custom-${Date.now()}`,
    name: app.name || app.title || 'Unnamed App',
  };

  safeSetItem(ACTIVE_APP_KEY, JSON.stringify(payload));
};

export const clearActiveApp = () => {
  safeSetItem(ACTIVE_APP_KEY, null);
};

export { ACTIVE_APP_KEY };

